import { ECompanySubscriptionType, ICompanySubscriptionFeature } from '../admin/subscription.types';
import { EOrganizationType, ERoleName } from '../company/types';

export enum EUserLanguage {
  ZH_CN = 'zh-CN',
  ZH_HK = 'zh-HK',
  EN_US = 'en-US'
}

export type UserPermission =
  | 'SAAS_ADMIN'
  | 'AMI'
  | 'WEALTHLINK'
  | 'OPENAPI'
  | 'ORG_ADMIN'
  | 'SPREADI'
  | 'SPREADI2'
  | 'MDA'
  | 'CSR_RECORD'
  | 'ESG_RATING'
  | 'ESG_HUB'
  | 'EHS';

export enum EAuthType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}

export interface IWhoAmIRequest { }
export interface IWhoAmIResponse {
  authType: EAuthType;
  basicInfo: {
    userId: string;
    organization: string;
    email: string;
    alias: string;
    prefix: string;
    companyName: string;
    firstName: string;
    middleName: string;
    lastName: string;
    phone: string;
    address: string;
    region: string;
    activated: boolean;
    language: string;
    userRoleId: number;
    userRole: string;
  };
  companyLogoUrl: string;
  permissions: UserPermission[];
  preference: {
    userId: string;
    organization: string;
    currency: string;
    language: EUserLanguage;
  };
  subscription: string;
  userId: string;
}

export enum ECompanyType {
  FI = 'FI',
  M_CORP = 'M_CORP',
  S_CORP = 'S_CORP',
  NGO = 'NGO',
  PO = 'PO',
  ENTERPRISE = 'ENTERPRISE',
  BANK = 'BANK',
  INVESTMENT_ORGANIZATION = 'INVESTMENT_ORGANIZATION'
}

export enum ECompanySize {
  SMALL_AND_MEDIUM = 'SMALL_AND_MEDIUM',
  MEDIUM_AND_LARGE = 'MEDIUM_AND_LARGE'
}

export enum ESubscriptionPlan {
  LITE = 'LITE',
  PRO = 'PRO',
  COMMUNITY = 'COMMUNITY'
}

export interface IInternalWhoAmiResponse {
  companyName: string;
  companyId: string;
  companyType: EOrganizationType;
  // TODO: subscriptionPlan delete
  subscriptionPlan: ESubscriptionPlan;
  subscriptionFeature: ICompanySubscriptionFeature[];
  subscriptionType: ECompanySubscriptionType;
  roleInfo: {
    roleId: string;
    roleName: ERoleName;
    module: string;
  }[];
  role: string; //MOODYS_ADMIN 用来判断是否是Moodys管理员
}

export interface IEditUserInfo {
  userId: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface IRemainingTaskQuotaResponse {
  remainingTaskQuota: number | null;
  totalTaskQuota: number | null;
}

export enum EOperationType {
  login = 0,
  logout = 1
}

export interface IUserLog {
  email: string;
  firstName: string;
  lastName: string;
  type: EOperationType;
  createTime: string;
}
export interface IRatingRequestType {
  requestReportId: string;
  requestCompanyId: string;
  requestCompanyName: string;
  ratingType: string;
  ratingStartYear: string;
  ratingEndYear: string;
  ratingReportStatus: string;
}

export interface ISessionInfo {
  builtInRoleList: EFeature[];
  customRoleList: RoleItem[];
  dataScope: EDataScope;
  departmentPathList: DepartmentItem[][],
  orgId: string;
  userId: string;
  fullName: string;
  email: string;
  resourceList: IResourceItem[]; // 资源列表
  [property: string]: any;
}
export interface IResourceItem {
  id: string; // 资源ID
  resourceName: string; // 资源名称
  resourceType?: string; // 资源类型
  resourceKey: string; // 资源标识
  routePath: string; // 前端路由路径
  component: string; // 前端组件
  parentId: string; // 父级ID
  displayOrder: string; // 展示顺序
  selected: boolean; // 是否选中
}
export interface RoleItem {
  dataScope: EDataScope;
  id: string;
  roleKey?: string;
  roleName: string;
  [property: string]: any;
}
/**
 * 数据可见范围
 */
export enum EDataScope {
  ALL = "ALL",
  ORGANIZATION = "ORGANIZATION",
  SELF = "SELF",
  DEPARTMENT = "DEPARTMENT",
  DEPARTMENT_CONTAINS_SUB = "DEPARTMENT_CONTAINS_SUB",
}

export enum EFeature {
  OrgAdmin = 'ORG_ADMIN',
  SysAdmin = "SYS_ADMIN", // 系统管理员
}
export interface DepartmentItem {
  departmentName: string;
  displayOrder: number;
  id: number;
  level: number
  parentId: number;
  path: string;
}